import Vue from 'vue';
import _ from 'lodash';
import {
    // 商品分类
    GET_GOODS_CATES_REQUEST,
    GET_GOODS_CATES_SUCCESS,
    GET_GOODS_CATES_FAILURE,
    // 商品列表
    GET_GOODS_LIST_REQUEST,
    GET_GOODS_LIST_SUCCESS,
    GET_GOODS_LIST_FAILURE,
    CLEAR_GOODS_CATES_BY_LEVEL,
    UPDATE_GOODS_LIST_PARAMS,
    GOODS_LIST_CHOSEN_ITEM,
    GOODS_LIST_CHOSEN_ADD_ITEM,
    EDIT_GOODS_ITEM_PROPS,
    UPDATE_CHOSEN_GOODS_IDS,
    INIT_ORDER_CHOSEN_GOODS,
    INIT_ORDER_CHOSEN_GOODS_IDS,
    GOODS_LIST_CONFIG_RESET,
    // GOODS_TEMP_LIST_CHOOSE_ADD_ITEM,
    // 保养
    // GET_MAINTENANCE_INFO_REQUEST,
    // GET_MAINTENANCE_INFO_SUCCESS,
    // GET_MAINTENANCE_INFO_FAILURE,
    // MAINTENANCE_ID_UPDATE
} from '../mutationTypes';

const state = {
    cateLoading: false,
    listLoading: false,
    // maintenanceLoading: false,
    cateL1: [],
    cateL2: [],
    cateL3: [],
    list: [],
    // maintenanceList: [],
    // maintenanceId: '',
    chosenIds: [], // 使用 `${type}_${goodsId}` 作为主键 商品订单为`order_${goodsOrder}`
    chosenGoods: [],
    hasMore: true,
    goodsTotal: 0,
    params: {
        page: 1,
        pagesize: 10,
        cate1_id: '',
        cate2_id: '',
        cate3_id: '',
        goodsName: '',
        goodsBrand: '',
        barCode: '',
        status: 1, // 上下架状态 默认1上架 0下架 2全部
    },
};

const mutations = {
    // 商品
    [INIT_ORDER_CHOSEN_GOODS](state, chosenGoods) {
        state.chosenGoods = chosenGoods;
    },
    [INIT_ORDER_CHOSEN_GOODS_IDS](state, ids) {
        state.chosenIds = ids;
    },
    [GET_GOODS_CATES_REQUEST](state) {
        state.cateLoading = true;
    },
    [GET_GOODS_CATES_SUCCESS](state, res) {
        state.cateLoading = false;

        const { level } = res;

        state[`cateL${level || 1 || 4}`] = res.list;
    },
    [GET_GOODS_CATES_FAILURE](state) {
        state.cateLoading = false;
    },
    [GET_GOODS_LIST_REQUEST](state) {
        state.listLoading = true;
    },
    [GET_GOODS_LIST_SUCCESS](state, res) {
        state.listLoading = false;
        const oldList = state.list;
        const fromatList = _.map(res.list,
            item => Object.assign({}, item, {
                uniqueId: `${item.type}_${item.goodsId}`,
            })
        );

        if (res.page === 1) {
            state.list = fromatList;
        } else {
            state.list = oldList.concat(fromatList);
        }

        if (res.page < res.page_count) {
            state.hasMore = true;
        } else {
            state.hasMore = false;
        }
    },
    [GET_GOODS_LIST_FAILURE](state) {
        state.listLoading = false;
    },
    [CLEAR_GOODS_CATES_BY_LEVEL](state, level) {
        if (level === 2) {
            // 一级不用清空
            state.cateL2 = [];
            state.params.cate2_id = '';
            state.cateL3 = [];
            state.params.cate3_id = '';
        } else if (level === 3) {
            state.cateL3 = [];
            state.params.cate3_id = '';
        }
    },
    [UPDATE_GOODS_LIST_PARAMS](state, obj) {
        state.params[obj.k] = obj.val;
    },
    // 编辑商品LIST项
    [GOODS_LIST_CHOSEN_ITEM](state, chosenIds) {
        state.chosenGoods = _.map(chosenIds, (id) => {
            const index = _.findIndex(state.chosenGoods, { uniqueId: id });
            return Object.assign({}, state.chosenGoods[index]);
        });

        let total = 0;
        _.forEach(state.chosenGoods, (item) => {
            total = item.goodsOrder ? total : total + item.goodsSubtotal;
        });
        state.goodsTotal = total;
    },
    // 新增项
    [GOODS_LIST_CHOSEN_ADD_ITEM](state, goodsItem) {
        if (goodsItem.goodsOrder) {
            state.chosenIds.push(goodsItem.uniqueId);
            state.chosenGoods.push(Object.assign({}, goodsItem));
        } else {
            if (goodsItem.goodsName) {
                state.chosenIds.push(goodsItem.uniqueId);
            }
            const goodsNum = Number(goodsItem.goodsNum) || 1;
            const goodsSubtotal = Number(goodsNum) * Number(goodsItem.goodsPrice);
            state.chosenGoods.push(Object.assign({}, {
                goodsId: goodsItem.goodsId,
                uniqueId: goodsItem.uniqueId,
                goodsName: goodsItem.goodsName,
                goodsNum,
                goodsPrice: goodsItem.goodsPrice,
                goodsSubtotal,
                goodsType: goodsItem.type,
                repertory: goodsItem.repertory,
                specification: goodsItem.specification,
                isDel: 0, // 0正常 1已删除
                isNoSales: 0, // 0正常 1禁售
                isNoShow: 0, // 0正常 1下架
            }));
        }
        let allTotal = 0;
        _.forEach(state.chosenGoods, (item) => {
            allTotal = item.goodsOrder ? allTotal : allTotal + item.goodsSubtotal;
        });

        state.goodsTotal = allTotal;
    },

    // 编辑项
    [EDIT_GOODS_ITEM_PROPS](state, { id, k, val }) {
        const itemIndex = _.findIndex(state.chosenGoods, { uniqueId: id });
        state.chosenGoods[itemIndex][k] = val;

        let total = 0;
        _.forEach(state.chosenGoods, (item) => {
            total = item.goodsOrder ? total : total + item.goodsSubtotal;
        });

        state.goodsTotal = total;
    },
    [UPDATE_CHOSEN_GOODS_IDS](state, ids) {
        state.chosenIds = JSON.parse(JSON.stringify(ids));
    },

    // [GET_MAINTENANCE_INFO_REQUEST](state) {
    //     state.maintenanceLoading = true;
    // },
    // [GET_MAINTENANCE_INFO_SUCCESS](state, res) {
    //     state.maintenanceLoading = false;
    //     const formatMaintList = _.map(res.maintenance_list,
    //         item => Object.assign({}, item, {
    //             uniqueId: `${item.type}_${item.goodsId}`,
    //         })
    //     );

    //     state.maintenanceList = formatMaintList;
    //     state.maintenanceId = res.maintenance_id;
    // },
    // [GET_MAINTENANCE_INFO_FAILURE](state) {
    //     state.maintenanceLoading = false;

    //     state.maintenanceList = [];
    // },
    // [MAINTENANCE_ID_UPDATE](state, id) {
    //     state.maintenanceId = id;
    // },
    [GOODS_LIST_CONFIG_RESET](state) {
        _.extend(state, _.cloneDeep({
            cateLoading: false,
            listLoading: false,
            // maintenanceLoading: false,
            cateL1: [],
            cateL2: [],
            cateL3: [],
            list: [],
            // maintenanceList: [],
            // maintenanceId: '',
            chosenIds: [], // 使用 `${type}_${goodsId}` 作为主键 商品订单为`order_${goodsOrder}`
            chosenGoods: [],
            hasMore: true,
            goodsTotal: 0,
            params: {
                page: 1,
                pagesize: 10,
                cate1_id: '',
                cate2_id: '',
                cate3_id: '',
                goodsName: '',
                goodsBrand: '',
                barCode: '',
                status: 1, // 上下架状态 默认1上架 0下架 2全部
            }
        }));
    },
};

export const actions = {
    initChosenGoods({ commit }, detail) {
        const { setChosenGoodsIds, setChosenGoods} = detail;
        commit(INIT_ORDER_CHOSEN_GOODS, setChosenGoods);
        commit(INIT_ORDER_CHOSEN_GOODS_IDS, setChosenGoodsIds);
    },
    async getGoodsList({ commit }, reqParams) {
        commit(GET_GOODS_LIST_REQUEST);

        const res = await Vue.$ajax.get('getStoreGoodsList', reqParams);

        if (!res.errorType) {
            commit(GET_GOODS_LIST_SUCCESS, res);
        } else {
            commit(GET_GOODS_LIST_FAILURE);
        }
    },

    async getGoodsCates({ commit }, query) {
        commit(GET_GOODS_CATES_REQUEST);

        const { level, cateId, isOrthers} = query;

        const list = await Vue.$ajax.get('getGoodsCate', {
            cateId,
            isOrthers
        });

        const res = {
            list,
            level
        };

        if (!list.errorType) {
            commit(GET_GOODS_CATES_SUCCESS, res);
        } else {
            commit(GET_GOODS_CATES_FAILURE);
        }
    },
    // async getMaintanceGoods({ commit }, query) {
    //     commit(GET_MAINTENANCE_INFO_REQUEST);

    //     const res = await Vue.$ajax.get('maintenanceList', query);

    //     if (!res.errorType) {
    //         commit(GET_MAINTENANCE_INFO_SUCCESS, res);
    //     } else {
    //         commit(GET_MAINTENANCE_INFO_FAILURE);
    //     }
    // },
    updateChosenGoods({ commit }, ids) {
        commit(GOODS_LIST_CHOSEN_ITEM, ids);
    },
    updateChosenGoodsIds({ commit }, ids) {
        commit(UPDATE_CHOSEN_GOODS_IDS, ids);
    },
    editChosenGoodsItem({ commit }, valObj) {
        commit(EDIT_GOODS_ITEM_PROPS, valObj);
    },
    // updateMaintenanceId({ commit }, id) {
    //     commit(MAINTENANCE_ID_UPDATE, id);
    // },
    resetAddGoods({ commit }) {
        commit(GOODS_LIST_CONFIG_RESET);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/goodsList.js